var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.11778 15.75C7.8767 15.75 6.66349 15.3819 5.63157 14.6924C4.59965 14.0029 3.79537 13.0229 3.32043 11.8763C2.84549 10.7297 2.72123 9.46799 2.96335 8.25076C3.20547 7.03353 3.80311 5.91543 4.68068 5.03786C5.55826 4.16028 6.67635 3.56265 7.89358 3.32053C9.11081 3.0784 10.3725 3.20267 11.5191 3.67761C12.6657 4.15255 13.6457 4.95683 14.3352 5.98875C15.0248 7.02067 15.3928 8.23388 15.3928 9.47495C15.3928 10.299 15.2305 11.115 14.9151 11.8763C14.5998 12.6376 14.1376 13.3294 13.5549 13.912C12.9722 14.4947 12.2804 14.9569 11.5191 15.2723C10.7578 15.5876 9.94182 15.75 9.11778 15.75ZM9.11778 4.45829C8.12887 4.45829 7.16217 4.75153 6.33992 5.30094C5.51768 5.85035 4.87682 6.63124 4.49838 7.54487C4.11994 8.4585 4.02092 9.46383 4.21385 10.4337C4.40678 11.4036 4.88298 12.2946 5.58224 12.9938C6.2815 13.6931 7.17242 14.1693 8.14232 14.3622C9.11223 14.5551 10.1176 14.4561 11.0312 14.0777C11.9448 13.6992 12.7257 13.0584 13.2751 12.2361C13.8245 11.4139 14.1178 10.4472 14.1178 9.45829C14.1178 8.1322 13.591 6.86044 12.6533 5.92275C11.7156 4.98507 10.4439 4.45829 9.11778 4.45829Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8095 17.7917C16.7274 17.7921 16.646 17.776 16.5702 17.7446C16.4943 17.7131 16.4255 17.6668 16.3678 17.6083L12.9262 14.1667C12.8158 14.0482 12.7557 13.8915 12.7585 13.7296C12.7614 13.5677 12.827 13.4132 12.9415 13.2987C13.056 13.1841 13.2105 13.1186 13.3724 13.1157C13.5343 13.1128 13.691 13.1729 13.8095 13.2833L17.2512 16.725C17.3682 16.8422 17.4339 17.0011 17.4339 17.1667C17.4339 17.3323 17.3682 17.4912 17.2512 17.6083C17.1935 17.6668 17.1247 17.7131 17.0488 17.7446C16.973 17.776 16.8916 17.7921 16.8095 17.7917Z",
    fill: "currentColor"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0925 17.9074C15.7065 17.9074 16.2953 17.6635 16.7294 17.2294C17.1635 16.7953 17.4074 16.2065 17.4074 15.5925C17.4074 14.9786 17.1635 14.3898 16.7294 13.9557C16.2953 13.5216 15.7065 13.2777 15.0925 13.2777C14.4786 13.2777 13.8898 13.5216 13.4557 13.9557C13.0216 14.3898 12.7777 14.9786 12.7777 15.5925C12.7777 16.2065 13.0216 16.7953 13.4557 17.2294C13.8898 17.6635 14.4786 17.9074 15.0925 17.9074ZM15.0925 18.8333C15.952 18.8333 16.7763 18.4919 17.3841 17.8841C17.9919 17.2763 18.3333 16.452 18.3333 15.5925C18.3333 14.733 17.9919 13.9088 17.3841 13.301C16.7763 12.6932 15.952 12.3518 15.0925 12.3518C14.233 12.3518 13.4088 12.6932 12.801 13.301C12.1932 13.9088 11.8518 14.733 11.8518 15.5925C11.8518 16.452 12.1932 17.2763 12.801 17.8841C13.4088 18.4919 14.233 18.8333 15.0925 18.8333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0925 13.9722C15.2153 13.9722 15.333 14.021 15.4199 14.1078C15.5067 14.1946 15.5555 14.3124 15.5555 14.4352V15.4009L15.8828 15.7282C15.9671 15.8155 16.0138 15.9325 16.0127 16.0539C16.0117 16.1753 15.963 16.2914 15.8771 16.3772C15.7913 16.463 15.6752 16.5117 15.5538 16.5128C15.4324 16.5138 15.3155 16.4672 15.2282 16.3828L14.6295 15.7842V14.4352C14.6295 14.3124 14.6783 14.1946 14.7651 14.1078C14.852 14.021 14.9697 13.9722 15.0925 13.9722ZM5.37028 10.037H4.44436V10.9629H5.37028V10.037ZM4.44436 9.11108C4.19879 9.11108 3.96327 9.20864 3.78963 9.38228C3.61599 9.55593 3.51843 9.79144 3.51843 10.037V10.9629C3.51843 11.2085 3.61599 11.444 3.78963 11.6177C3.96327 11.7913 4.19879 11.8889 4.44436 11.8889H5.37028C5.61586 11.8889 5.85137 11.7913 6.02501 11.6177C6.19866 11.444 6.29621 11.2085 6.29621 10.9629V10.037C6.29621 9.79144 6.19866 9.55593 6.02501 9.38228C5.85137 9.20864 5.61586 9.11108 5.37028 9.11108H4.44436ZM9.07399 10.037H8.14806V10.9629H9.07399V10.037ZM8.14806 9.11108C7.90249 9.11108 7.66698 9.20864 7.49333 9.38228C7.31969 9.55593 7.22214 9.79144 7.22214 10.037V10.9629C7.22214 11.2085 7.31969 11.444 7.49333 11.6177C7.66698 11.7913 7.90249 11.8889 8.14806 11.8889H9.07399C9.31956 11.8889 9.55507 11.7913 9.72872 11.6177C9.90236 11.444 9.99991 11.2085 9.99991 10.9629V10.037C9.99991 9.79144 9.90236 9.55593 9.72872 9.38228C9.55507 9.20864 9.31956 9.11108 9.07399 9.11108H8.14806ZM12.7777 10.037H11.8518V10.9629H12.7777V10.037ZM11.8518 9.11108C11.6062 9.11108 11.3707 9.20864 11.197 9.38228C11.0234 9.55593 10.9258 9.79144 10.9258 10.037V10.9629C10.9258 11.2085 11.0234 11.444 11.197 11.6177C11.3707 11.7913 11.6062 11.8889 11.8518 11.8889H12.7777C13.0233 11.8889 13.2588 11.7913 13.4324 11.6177C13.6061 11.444 13.7036 11.2085 13.7036 10.9629V10.037C13.7036 9.79144 13.6061 9.55593 13.4324 9.38228C13.2588 9.20864 13.0233 9.11108 12.7777 9.11108H11.8518ZM5.37028 13.7407H4.44436V14.6666H5.37028V13.7407ZM4.44436 12.8148C4.19879 12.8148 3.96327 12.9123 3.78963 13.086C3.61599 13.2596 3.51843 13.4951 3.51843 13.7407V14.6666C3.51843 14.9122 3.61599 15.1477 3.78963 15.3214C3.96327 15.495 4.19879 15.5926 4.44436 15.5926H5.37028C5.61586 15.5926 5.85137 15.495 6.02501 15.3214C6.19866 15.1477 6.29621 14.9122 6.29621 14.6666V13.7407C6.29621 13.4951 6.19866 13.2596 6.02501 13.086C5.85137 12.9123 5.61586 12.8148 5.37028 12.8148H4.44436ZM9.07399 13.7407H8.14806V14.6666H9.07399V13.7407ZM8.14806 12.8148C7.90249 12.8148 7.66698 12.9123 7.49333 13.086C7.31969 13.2596 7.22214 13.4951 7.22214 13.7407V14.6666C7.22214 14.9122 7.31969 15.1477 7.49333 15.3214C7.66698 15.495 7.90249 15.5926 8.14806 15.5926H9.07399C9.31956 15.5926 9.55507 15.495 9.72872 15.3214C9.90236 15.1477 9.99991 14.9122 9.99991 14.6666V13.7407C9.99991 13.4951 9.90236 13.2596 9.72872 13.086C9.55507 12.9123 9.31956 12.8148 9.07399 12.8148H8.14806Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59255 4.94443C2.59255 4.82165 2.64133 4.70389 2.72815 4.61707C2.81497 4.53024 2.93273 4.48147 3.05551 4.48147H5.37033V3.55554H3.05551C2.68716 3.55554 2.33389 3.70187 2.07342 3.96234C1.81295 4.22281 1.66663 4.57607 1.66663 4.94443V16.0555C1.66663 16.4239 1.81295 16.7772 2.07342 17.0376C2.33389 17.2981 2.68716 17.4444 3.05551 17.4444H12.4328C12.2354 17.1616 12.0846 16.849 11.9861 16.5185H3.05551C2.93273 16.5185 2.81497 16.4697 2.72815 16.3829C2.64133 16.2961 2.59255 16.1783 2.59255 16.0555V4.94443ZM14.6296 12.3842C14.9367 12.3403 15.2484 12.3403 15.5555 12.3842V4.94443C15.5555 4.57607 15.4092 4.22281 15.1487 3.96234C14.8882 3.70187 14.535 3.55554 14.1666 3.55554H12.7777V4.48147H14.1666C14.2894 4.48147 14.4072 4.53024 14.494 4.61707C14.5808 4.70389 14.6296 4.82165 14.6296 4.94443V12.3842ZM6.29626 4.48147H11.1865V3.55554H6.29626V4.48147Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5555 7.72219H2.59253V6.79626H15.5555V7.72219Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44434 2.62959C4.44434 2.5068 4.49311 2.38905 4.57993 2.30222C4.66676 2.2154 4.78451 2.16663 4.9073 2.16663C5.03008 2.16663 5.14784 2.2154 5.23466 2.30222C5.32149 2.38905 5.37026 2.5068 5.37026 2.62959V4.9444C5.37026 5.06719 5.32149 5.18495 5.23466 5.27177C5.14784 5.35859 5.03008 5.40737 4.9073 5.40737C4.78451 5.40737 4.66676 5.35859 4.57993 5.27177C4.49311 5.18495 4.44434 5.06719 4.44434 4.9444V2.62959ZM10.9258 2.62959C10.9258 2.5068 10.9746 2.38905 11.0614 2.30222C11.1482 2.2154 11.266 2.16663 11.3888 2.16663C11.5116 2.16663 11.6293 2.2154 11.7161 2.30222C11.803 2.38905 11.8517 2.5068 11.8517 2.62959V4.9444C11.8517 5.06719 11.803 5.18495 11.7161 5.27177C11.6293 5.35859 11.5116 5.40737 11.3888 5.40737C11.266 5.40737 11.1482 5.35859 11.0614 5.27177C10.9746 5.18495 10.9258 5.06719 10.9258 4.9444V2.62959Z",
    fill: "currentColor"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "phone",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8961 3.46325C11.9173 3.38393 11.954 3.30956 12.0039 3.24441C12.0539 3.17926 12.1162 3.12458 12.1873 3.08352C12.2584 3.04245 12.3369 3.0158 12.4183 3.00509C12.4997 2.99437 12.5824 2.9998 12.6617 3.02106C13.8204 3.32336 14.8775 3.92906 15.7242 4.77577C16.5709 5.62249 17.1766 6.6796 17.4789 7.83825C17.5002 7.91755 17.5056 8.00027 17.4949 8.08168C17.4842 8.16308 17.4575 8.24158 17.4165 8.31268C17.3754 8.38378 17.3207 8.44609 17.2556 8.49605C17.1904 8.54602 17.116 8.58265 17.0367 8.60387C16.9839 8.61774 16.9296 8.62483 16.875 8.62496C16.7373 8.62496 16.6034 8.57946 16.4942 8.49554C16.385 8.41163 16.3066 8.29398 16.2711 8.1609C16.0245 7.21506 15.5302 6.35208 14.8391 5.66092C14.1479 4.96976 13.2849 4.47542 12.3391 4.22887C12.2597 4.20774 12.1852 4.17116 12.12 4.12123C12.0548 4.07131 12 4.009 11.9589 3.9379C11.9177 3.86679 11.891 3.78826 11.8802 3.70682C11.8695 3.62537 11.8749 3.5426 11.8961 3.46325ZM11.7141 6.72887C12.7914 7.01637 13.4836 7.70856 13.7711 8.7859C13.8066 8.91898 13.885 9.03663 13.9942 9.12054C14.1034 9.20446 14.2373 9.24996 14.375 9.24996C14.4296 9.24983 14.4839 9.24274 14.5367 9.22887C14.616 9.20765 14.6904 9.17102 14.7556 9.12105C14.8207 9.07109 14.8754 9.00878 14.9165 8.93768C14.9575 8.86658 14.9842 8.78808 14.9949 8.70668C15.0056 8.62527 15.0002 8.54255 14.9789 8.46325C14.5789 6.96637 13.5336 5.92106 12.0367 5.52106C11.9574 5.49987 11.8747 5.49451 11.7933 5.50529C11.712 5.51607 11.6335 5.54276 11.5624 5.58386C11.4914 5.62496 11.4291 5.67965 11.3792 5.74481C11.3293 5.80997 11.2927 5.88433 11.2715 5.96364C11.2503 6.04294 11.2449 6.12564 11.2557 6.20702C11.2665 6.2884 11.2932 6.36686 11.3343 6.43791C11.3754 6.50897 11.4301 6.57124 11.4952 6.62116C11.5604 6.67109 11.6348 6.70768 11.7141 6.72887ZM18.1156 14.1781C17.9763 15.2367 17.4564 16.2084 16.6531 16.9117C15.8497 17.6151 14.8177 18.0019 13.75 18C7.54688 18 2.50001 12.9531 2.50001 6.74996C2.49809 5.68222 2.88492 4.65029 3.58824 3.84691C4.29155 3.04353 5.26326 2.52364 6.32188 2.38434C6.58958 2.35165 6.86067 2.40642 7.09468 2.54046C7.3287 2.67451 7.51309 2.88064 7.62032 3.12809L9.27032 6.81168V6.82106C9.35242 7.01047 9.38633 7.21728 9.36901 7.42299C9.3517 7.62871 9.2837 7.82693 9.1711 7.99996C9.15704 8.02106 9.14219 8.04059 9.12657 8.06012L7.50001 9.98825C8.08516 11.1773 9.32891 12.4101 10.5336 12.9968L12.4352 11.3789C12.4538 11.3632 12.4734 11.3486 12.4938 11.3351C12.6666 11.2198 12.8655 11.1494 13.0725 11.1303C13.2794 11.1112 13.4878 11.144 13.6789 11.2257L13.6891 11.2304L17.3695 12.8797C17.6174 12.9865 17.8241 13.1707 17.9585 13.4048C18.093 13.6388 18.1481 13.9101 18.1156 14.1781ZM16.875 14.0218H16.8664L13.1945 12.3773L11.2922 13.9953C11.2737 14.0109 11.2544 14.0255 11.2344 14.039C11.0545 14.159 10.8466 14.2303 10.6309 14.2459C10.4152 14.2615 10.1992 14.2209 10.0039 14.1281C8.54063 13.4211 7.08204 11.9734 6.37423 10.5257C6.2805 10.3319 6.23844 10.1171 6.25213 9.9022C6.26582 9.6873 6.33478 9.47959 6.45235 9.29918C6.4656 9.278 6.48049 9.25789 6.49688 9.23903L8.12501 7.30856L6.48438 3.63668C6.48407 3.63357 6.48407 3.63042 6.48438 3.62731C5.72677 3.72613 5.03116 4.09775 4.52783 4.67255C4.0245 5.24736 3.74796 5.98593 3.75001 6.74996C3.7529 9.40124 4.8074 11.9431 6.68214 13.8178C8.55687 15.6926 11.0987 16.7471 13.75 16.75C14.5136 16.7526 15.2519 16.477 15.8271 15.9748C16.4022 15.4725 16.7747 14.778 16.875 14.0211V14.0218Z",
    fill: "currentColor"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "instagram",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.44578C10.1205 1.44578 10.4096 1.44578 11.2771 1.44578C12.0482 1.44578 12.4337 1.63855 12.7229 1.73494C13.1084 1.92771 13.3976 2.0241 13.6867 2.31325C13.9759 2.60241 14.1687 2.89157 14.2651 3.27711C14.3614 3.56627 14.4578 3.95181 14.5542 4.72289C14.5542 5.59036 14.5542 5.78313 14.5542 8C14.5542 10.2169 14.5542 10.4096 14.5542 11.2771C14.5542 12.0482 14.3614 12.4337 14.2651 12.7229C14.0723 13.1084 13.9759 13.3976 13.6867 13.6867C13.3976 13.9759 13.1084 14.1687 12.7229 14.2651C12.4337 14.3614 12.0482 14.4578 11.2771 14.5542C10.4096 14.5542 10.2169 14.5542 8 14.5542C5.78313 14.5542 5.59036 14.5542 4.72289 14.5542C3.95181 14.5542 3.56627 14.3614 3.27711 14.2651C2.89157 14.0723 2.60241 13.9759 2.31325 13.6867C2.0241 13.3976 1.83133 13.1084 1.73494 12.7229C1.63855 12.4337 1.54217 12.0482 1.44578 11.2771C1.44578 10.4096 1.44578 10.2169 1.44578 8C1.44578 5.78313 1.44578 5.59036 1.44578 4.72289C1.44578 3.95181 1.63855 3.56627 1.73494 3.27711C1.92771 2.89157 2.0241 2.60241 2.31325 2.31325C2.60241 2.0241 2.89157 1.83133 3.27711 1.73494C3.56627 1.63855 3.95181 1.54217 4.72289 1.44578C5.59036 1.44578 5.87952 1.44578 8 1.44578ZM8 0C5.78313 0 5.59036 0 4.72289 0C3.85542 0 3.27711 0.192772 2.79518 0.385543C2.31325 0.578314 1.83133 0.867471 1.3494 1.3494C0.867471 1.83133 0.674699 2.21687 0.385543 2.79518C0.192772 3.27711 0.0963856 3.85542 0 4.72289C0 5.59036 0 5.87952 0 8C0 10.2169 0 10.4096 0 11.2771C0 12.1446 0.192772 12.7229 0.385543 13.2048C0.578314 13.6867 0.867471 14.1687 1.3494 14.6506C1.83133 15.1325 2.21687 15.3253 2.79518 15.6145C3.27711 15.8072 3.85542 15.9036 4.72289 16C5.59036 16 5.87952 16 8 16C10.1205 16 10.4096 16 11.2771 16C12.1446 16 12.7229 15.8072 13.2048 15.6145C13.6867 15.4217 14.1687 15.1325 14.6506 14.6506C15.1325 14.1687 15.3253 13.7831 15.6145 13.2048C15.8072 12.7229 15.9036 12.1446 16 11.2771C16 10.4096 16 10.1205 16 8C16 5.87952 16 5.59036 16 4.72289C16 3.85542 15.8072 3.27711 15.6145 2.79518C15.4217 2.31325 15.1325 1.83133 14.6506 1.3494C14.1687 0.867471 13.7831 0.674699 13.2048 0.385543C12.7229 0.192772 12.1446 0.0963856 11.2771 0C10.4096 0 10.2169 0 8 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.85542C5.68675 3.85542 3.85542 5.68675 3.85542 8C3.85542 10.3133 5.68675 12.1446 8 12.1446C10.3133 12.1446 12.1446 10.3133 12.1446 8C12.1446 5.68675 10.3133 3.85542 8 3.85542ZM8 10.6988C6.55422 10.6988 5.30121 9.54217 5.30121 8C5.30121 6.55422 6.45783 5.30121 8 5.30121C9.44578 5.30121 10.6988 6.45783 10.6988 8C10.6988 9.44578 9.44578 10.6988 8 10.6988Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.241 4.72289C12.7733 4.72289 13.2048 4.29136 13.2048 3.75904C13.2048 3.22671 12.7733 2.79518 12.241 2.79518C11.7086 2.79518 11.2771 3.22671 11.2771 3.75904C11.2771 4.29136 11.7086 4.72289 12.241 4.72289Z",
    fill: "currentColor"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "facebook",
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32568 10.2918H9.30342L9.77095 7.24834H6.32507V5.58498C6.32507 4.32069 6.73567 3.1996 7.91114 3.1996H9.80001V0.543695C9.46814 0.498608 8.76625 0.399902 7.43998 0.399902C4.67057 0.399902 3.04695 1.87134 3.04695 5.22366V7.24834H0.200012V10.2918H3.04695V18.6567C3.61076 18.742 4.18184 18.7999 4.76807 18.7999C5.29797 18.7999 5.81515 18.7512 6.32568 18.6817V10.2918Z",
    fill: "currentColor"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "whatsapp",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3415 2.65019C12.761 1.07519 10.6537 0.200195 8.42927 0.200195C3.80488 0.200195 0.0585357 3.93353 0.0585357 8.54186C0.0585357 10.0002 0.468293 11.4585 1.17073 12.6835L0 17.0002L4.44878 15.8335C5.67805 16.4752 7.02439 16.8252 8.42927 16.8252C13.0537 16.8252 16.8 13.0919 16.8 8.48353C16.7415 6.3252 15.9219 4.22519 14.3415 2.65019ZM12.4683 11.5169C12.2927 11.9835 11.4732 12.4502 11.0634 12.5085C10.7122 12.5669 10.2439 12.5669 9.77561 12.4502C9.48293 12.3335 9.07317 12.2169 8.60488 11.9835C6.49756 11.1085 5.15122 9.00853 5.03415 8.83353C4.91707 8.71686 4.1561 7.72519 4.1561 6.67519C4.1561 5.62519 4.68293 5.15853 4.85854 4.92519C5.03415 4.69186 5.26829 4.69186 5.4439 4.69186C5.56098 4.69186 5.73658 4.69186 5.85366 4.69186C5.97073 4.69186 6.14634 4.63353 6.32195 5.04186C6.49756 5.45019 6.90732 6.5002 6.96585 6.55853C7.02439 6.67519 7.02439 6.79186 6.96585 6.90853C6.90732 7.0252 6.84878 7.14186 6.7317 7.25853C6.61463 7.37519 6.49756 7.55019 6.43902 7.60853C6.32195 7.72519 6.20488 7.84186 6.32195 8.01686C6.43902 8.25019 6.84878 8.89186 7.49268 9.47519C8.31219 10.1752 8.9561 10.4085 9.19024 10.5252C9.42439 10.6419 9.54146 10.5835 9.65853 10.4669C9.77561 10.3502 10.1854 9.88353 10.3024 9.6502C10.4195 9.41686 10.5951 9.47519 10.7707 9.53353C10.9463 9.59186 12 10.1169 12.1756 10.2335C12.4098 10.3502 12.5268 10.4085 12.5854 10.4669C12.6439 10.6419 12.6439 11.0502 12.4683 11.5169Z",
    fill: "currentColor"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrowDown",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9841 5.1189C12.7221 4.93557 12.3656 4.97118 12.1451 5.20268L9.32411 8.1647C8.93003 8.5785 8.26993 8.5785 7.87584 8.1647L5.05486 5.20268C4.83438 4.97118 4.47781 4.93557 4.2159 5.1189C3.89177 5.34579 3.84562 5.80798 4.11848 6.09448L7.87584 10.0397C8.26993 10.4535 8.93003 10.4535 9.32411 10.0397L13.0815 6.09448C13.3543 5.80797 13.3082 5.34579 12.9841 5.1189Z",
    fill: "currentColor"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "globus",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_11803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 9.99996C1.66663 14.6025 5.39746 18.3333 9.99996 18.3333C14.6025 18.3333 18.3333 14.6025 18.3333 9.99996C18.3333 5.39746 14.6025 1.66663 9.99996 1.66663C5.39746 1.66663 1.66663 5.39746 1.66663 9.99996Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 1.70825C10.8333 1.70825 13.3333 4.99992 13.3333 9.99992C13.3333 14.9999 10.8333 18.2916 10.8333 18.2916M9.16665 18.2916C9.16665 18.2916 6.66665 14.9999 6.66665 9.99992C6.66665 4.99992 9.16665 1.70825 9.16665 1.70825M2.19165 12.9166H17.8083M2.19165 7.08325H17.8083",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_11803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "burger",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H3.75C3.55109 12.75 3.36032 12.671 3.21967 12.5303C3.07902 12.3897 3 12.1989 3 12C3 11.8011 3.07902 11.6103 3.21967 11.4697C3.36032 11.329 3.55109 11.25 3.75 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12ZM3.75 6.75H20.25C20.4489 6.75 20.6397 6.67098 20.7803 6.53033C20.921 6.38968 21 6.19891 21 6C21 5.80109 20.921 5.61032 20.7803 5.46967C20.6397 5.32902 20.4489 5.25 20.25 5.25H3.75C3.55109 5.25 3.36032 5.32902 3.21967 5.46967C3.07902 5.61032 3 5.80109 3 6C3 6.19891 3.07902 6.38968 3.21967 6.53033C3.36032 6.67098 3.55109 6.75 3.75 6.75ZM20.25 17.25H3.75C3.55109 17.25 3.36032 17.329 3.21967 17.4697C3.07902 17.6103 3 17.8011 3 18C3 18.1989 3.07902 18.3897 3.21967 18.5303C3.36032 18.671 3.55109 18.75 3.75 18.75H20.25C20.4489 18.75 20.6397 18.671 20.7803 18.5303C20.921 18.3897 21 18.1989 21 18C21 17.8011 20.921 17.6103 20.7803 17.4697C20.6397 17.329 20.4489 17.25 20.25 17.25Z",
    fill: "currentColor"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1679 22.8312L22.8352 11.1639",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1676 11.165L22.8349 22.8323",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "mail",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20001 7.2002C7.20001 7.04107 7.26322 6.88845 7.37574 6.77593C7.48827 6.66341 7.64088 6.6002 7.80001 6.6002H11.4C11.5591 6.6002 11.7118 6.66341 11.8243 6.77593C11.9368 6.88845 12 7.04107 12 7.2002C12 7.35933 11.9368 7.51194 11.8243 7.62446C11.7118 7.73698 11.5591 7.8002 11.4 7.8002H7.80001C7.64088 7.8002 7.48827 7.73698 7.37574 7.62446C7.26322 7.51194 7.20001 7.35933 7.20001 7.2002ZM7.80001 9.0002C7.64088 9.0002 7.48827 9.06341 7.37574 9.17593C7.26322 9.28845 7.20001 9.44107 7.20001 9.6002C7.20001 9.75933 7.26322 9.91194 7.37574 10.0245C7.48827 10.137 7.64088 10.2002 7.80001 10.2002H10.2C10.3591 10.2002 10.5118 10.137 10.6243 10.0245C10.7368 9.91194 10.8 9.75933 10.8 9.6002C10.8 9.44107 10.7368 9.28845 10.6243 9.17593C10.5118 9.06341 10.3591 9.0002 10.2 9.0002H7.80001ZM9.60001 1.2002C8.35087 1.19978 7.12311 1.52434 6.03736 2.14201C4.95162 2.75968 4.04525 3.6492 3.40732 4.72316C2.76938 5.79711 2.42183 7.01857 2.39881 8.2675C2.37578 9.51642 2.67809 10.7499 3.27601 11.8466L2.42401 14.8346C2.39403 14.9395 2.39323 15.0506 2.4217 15.156C2.45017 15.2613 2.50682 15.3569 2.58557 15.4324C2.66432 15.508 2.76217 15.5606 2.86861 15.5847C2.97504 15.6087 3.08602 15.6033 3.18961 15.569L5.99521 14.6342C6.95144 15.1868 8.02197 15.512 9.12398 15.5846C10.226 15.6572 11.33 15.4754 12.3505 15.0532C13.3709 14.6309 14.2806 13.9795 15.0091 13.1495C15.7376 12.3194 16.2654 11.3329 16.5516 10.2662C16.8378 9.19952 16.8748 8.0813 16.6597 6.99804C16.4447 5.91478 15.9833 4.89551 15.3113 4.01909C14.6392 3.14268 13.7746 2.4326 12.7843 1.9438C11.7939 1.45499 10.7044 1.20056 9.60001 1.2002ZM3.60001 8.4002C3.6002 7.06892 4.04315 5.77552 4.8591 4.72361C5.67506 3.6717 6.81768 2.92103 8.10709 2.58978C9.3965 2.25854 10.7595 2.36552 11.9814 2.8939C13.2033 3.42228 14.2148 4.34204 14.8566 5.50838C15.4985 6.67472 15.7342 8.02139 15.5267 9.33639C15.3191 10.6514 14.6802 11.86 13.7103 12.772C12.7405 13.684 11.4949 14.2476 10.1697 14.374C8.8444 14.5004 7.51474 14.1824 6.39001 13.4702C6.31477 13.4225 6.22986 13.3922 6.14144 13.3814C6.05302 13.3706 5.9633 13.3796 5.87881 13.4078L3.88921 14.0714L4.50121 11.9342C4.52351 11.8555 4.52947 11.773 4.51874 11.6919C4.50801 11.6108 4.48081 11.5328 4.43881 11.4626C3.88784 10.5363 3.59798 9.47801 3.60001 8.4002ZM14.7312 17.9366L11.8488 16.4966C12.3768 16.349 12.8844 16.1522 13.3644 15.911L15 16.7294L20.4 14.0294V13.2002C20.4 12.8819 20.2736 12.5767 20.0485 12.3517C19.8235 12.1266 19.5183 12.0002 19.2 12.0002H17.1912C17.3748 11.6162 17.5284 11.2142 17.652 10.8002H19.2C19.8365 10.8002 20.447 11.0531 20.8971 11.5031C21.3472 11.9532 21.6 12.5637 21.6 13.2002V19.2002C21.6 19.8367 21.3472 20.4472 20.8971 20.8973C20.447 21.3473 19.8365 21.6002 19.2 21.6002H10.8C10.1635 21.6002 9.55304 21.3473 9.10295 20.8973C8.65286 20.4472 8.40001 19.8367 8.40001 19.2002V16.7162C8.79241 16.7714 9.19201 16.8002 9.60001 16.8002V19.2002C9.60001 19.5185 9.72644 19.8237 9.95148 20.0487C10.1765 20.2738 10.4817 20.4002 10.8 20.4002H19.2C19.5183 20.4002 19.8235 20.2738 20.0485 20.0487C20.2736 19.8237 20.4 19.5185 20.4 19.2002V15.371L15.2688 17.9366C15.1854 17.9784 15.0933 18.0002 15 18.0002C14.9067 18.0002 14.8146 17.9784 14.7312 17.9366Z",
    fill: "currentColor"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "location",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5391 11.7378L16.5276 11.768C16.5312 11.7589 16.5341 11.7496 16.5377 11.7404L16.5391 11.7378Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 0C8.04575 0 4.79999 3.2352 4.79999 7.18128C4.79999 8.71056 5.28959 10.1357 6.11519 11.303L6.08567 11.257L10.6951 19.2245L10.7184 19.255C10.9041 19.4974 11.088 19.6927 11.3105 19.8398C11.5329 19.987 11.8178 20.0798 12.0977 20.0518C12.6569 19.9956 12.9818 19.6092 13.2821 19.2022L13.3008 19.177L18.3825 10.5288L18.3866 10.5216C18.5083 10.302 18.5964 10.0805 18.6717 9.86592C19.0203 9.01376 19.1997 8.10195 19.2 7.18128C19.2 3.2352 15.9552 0 12.0005 0ZM12.0005 1.2C15.3014 1.2 18 3.89232 18 7.18128C18.0002 7.94949 17.8502 8.71033 17.5584 9.42096L17.5524 9.43584L17.5471 9.45144C17.484 9.63312 17.4153 9.798 17.3361 9.94104L12.306 18.5009C12.0835 18.7939 11.928 18.8633 11.9779 18.858C12.0036 18.8556 12.0273 18.8758 11.9724 18.8393C11.9198 18.8045 11.8125 18.7025 11.6853 18.5402L7.11119 10.632L7.09511 10.6097C6.40559 9.63528 5.99999 8.4552 5.99999 7.18128C5.99999 3.89256 8.69951 1.2 12.0005 1.2ZM12.0005 3.084C9.72959 3.084 7.89287 4.91424 7.89287 7.18128C7.89287 9.44832 9.72983 11.2786 12.0005 11.2786C14.2711 11.2786 16.1071 9.44808 16.1071 7.18128C16.1071 4.91424 14.2711 3.084 12.0005 3.084ZM12.0005 4.284C13.6365 4.284 14.9071 5.5524 14.9071 7.18128C14.9071 8.81016 13.6368 10.0786 12.0005 10.0786C10.3641 10.0786 9.09287 8.80992 9.09287 7.18128C9.09287 5.5524 10.3644 4.284 12.0005 4.284Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16146 16.5737C4.77122 17.0528 2.40002 18.1988 2.40002 19.8857C2.40002 22.1581 6.36194 24.0001 12 24.0001C17.6381 24.0001 21.6 22.1581 21.6 19.8857C21.6 18.1988 19.2291 17.0528 15.8391 16.5737L15.3694 17.3734C17.9244 17.7279 19.68 18.4729 19.68 19.3373C19.68 20.5493 16.2415 21.5316 12 21.5316C7.7585 21.5316 4.32002 20.5493 4.32002 19.3373C4.31978 18.4757 6.06386 17.7315 8.62682 17.3756C8.47202 17.1082 8.3165 16.8413 8.16146 16.5737Z",
    fill: "currentColor"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "twitter",
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.48 1.9199C15.92 2.1599 15.28 2.3199 14.64 2.3999C15.28 1.9999 15.84 1.3599 16.08 0.639905C15.44 1.0399 14.8 1.2799 14 1.4399C13.44 0.799905 12.56 0.399902 11.68 0.399902C9.91998 0.399902 8.47998 1.8399 8.47998 3.5999C8.47998 3.8399 8.47998 4.0799 8.55998 4.3199C5.91999 4.1599 3.51998 2.8799 1.91998 0.9599C1.67998 1.4399 1.51998 1.9999 1.51998 2.5599C1.51998 3.6799 2.07999 4.6399 2.95999 5.1999C2.39999 5.1999 1.91998 5.0399 1.51998 4.7999C1.51998 6.3199 2.63998 7.6799 4.07998 7.9199C3.83998 7.9999 3.51999 7.9999 3.19999 7.9999C2.95999 7.9999 2.79999 7.9999 2.55999 7.9199C2.95999 9.1999 4.15999 10.1599 5.59999 10.1599C4.47999 11.0399 3.11999 11.5199 1.59999 11.5199C1.35999 11.5199 1.11999 11.5199 0.799988 11.4399C2.23999 12.3199 3.91999 12.8799 5.75998 12.8799C11.68 12.8799 14.88 7.9999 14.88 3.7599V3.3599C15.52 3.1199 16.08 2.5599 16.48 1.9199Z",
    fill: "currentColor"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "telegram",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4 1.08163L12.9957 13.6337C12.9957 13.6337 12.6593 14.5039 11.7351 14.0866L6.18767 9.68191L6.16195 9.66893C6.91128 8.97217 12.7219 3.56198 12.9759 3.31675C13.369 2.93694 13.125 2.71084 12.6685 2.99774L4.08545 8.64223L0.774123 7.48847C0.774123 7.48847 0.253018 7.29651 0.202886 6.87914C0.152095 6.46108 0.791273 6.23497 0.791273 6.23497L14.2905 0.751012C14.2905 0.751012 15.4 0.246197 15.4 1.08163Z",
    fill: "currentColor"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "youtube",
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01 11.6453C1.69619 11.5525 1.40986 11.3873 1.17518 11.1638C0.940491 10.9402 0.764334 10.6648 0.66157 10.3609C0.074349 8.78977 -0.0996426 2.22942 1.0313 0.934337C1.4077 0.513037 1.93913 0.253653 2.51023 0.212485C5.5442 -0.105978 14.918 -0.0635162 15.9946 0.31864C16.2974 0.414536 16.574 0.576083 16.8038 0.791175C17.0335 1.00627 17.2104 1.26933 17.3212 1.56065C17.9628 3.18481 17.9846 9.08701 17.2343 10.6475C17.0352 11.0537 16.702 11.3827 16.2882 11.5816C15.1572 12.1336 3.51068 12.123 2.01 11.6453ZM6.82739 8.56685L12.2646 5.80683L6.82739 3.02558V8.56685Z",
    fill: "currentColor"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrowRight",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2623 6.34314L24.0164 12L18.2623 17.6568",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0164 12H1.0002",
    stroke: "#0C101A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow",
    viewBox: "0 0 14 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.60033 24.1317L10.6957 16.0363C12.1894 14.5426 12.1894 12.1208 10.6957 10.627L2.60033 2.53165",
    stroke: "#AAAAAA",
    strokeWidth: 3.82492,
    strokeLinecap: "round"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "circleBubble",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_35_3718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5303 37.0694C31.4969 35.5285 33.7724 33.7396 36.0725 30.2454C38.3725 26.7513 37.1774 22.1765 33.5847 19.9395C29.992 17.7025 25.7939 19.0668 22.407 22.082C21.3353 23.0361 18.5856 24.9177 17.063 25.3695C14.4109 26.7848 6.03524 25.1182 6.98723 16.5633C3.98157 24.5362 8.17368 30.3777 9.28905 31.7993C15.4265 39.622 25.1146 38.2496 27.5303 37.0694Z",
    fill: "#02439B",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_35_3718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4702 6.93051C12.5036 8.4714 10.2281 10.2603 7.92804 13.7544C5.62794 17.2486 6.82305 21.8234 10.4158 24.0604C14.0085 26.2973 18.2066 24.9331 21.5934 21.9179C22.6652 20.9638 25.4149 19.0822 26.9375 18.6303C29.5896 17.2151 37.9653 18.8817 37.0133 27.4366C40.0189 19.4637 35.8268 13.6221 34.7114 12.2005C28.574 4.37786 18.8859 5.75024 16.4702 6.93051Z",
    fill: "#02439B",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_35_3718",
    x: -48.0781,
    y: -37.4366,
    width: 139.328,
    height: 129.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_35_3718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_35_3718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_35_3718",
    x: -47.2495,
    y: -47.9833,
    width: 139.328,
    height: 129.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_35_3718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_35_3718",
    result: "shape"
  }))))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "paginationArrow",
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_2535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30949 8.12084L5.18848 4.99983L8.30949 1.87881",
    stroke: "currentColor",
    strokeWidth: 1.24841,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18742 8.12084L2.06641 4.99983L5.18742 1.87881",
    stroke: "currentColor",
    strokeWidth: 1.24841,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_2535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.98726,
    height: 9.98726,
    fill: "white",
    transform: "translate(0.506836 0.0063715)"
  }))))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "cloud",
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0237 34.8333C7.68418 34.8333 4.16602 31.3573 4.16602 27.0692C4.16602 22.7792 7.68418 19.3032 12.0237 19.3032C12.5443 19.3032 13.054 19.3545 13.5453 19.4498M13.5453 19.4498C13.1147 18.2995 12.8949 17.0811 12.8963 15.8528C12.8963 10.1347 17.586 5.5 23.372 5.5C28.762 5.5 33.2005 9.52233 33.7853 14.6942M13.5453 19.4498C14.5597 19.6468 15.5253 20.0418 16.387 20.6122M26.8645 14.7162C27.9873 14.325 29.168 14.126 30.357 14.1277C31.556 14.1277 32.7092 14.3275 33.7853 14.6942M33.7853 14.6942C37.8847 16.0967 40.8327 19.9485 40.8327 24.4805C40.8327 29.4433 37.2998 33.5922 32.5827 34.6005",
    stroke: "#004098",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4987 40.3333V29.3333M22.4987 40.3333L26.1654 36.6666M22.4987 40.3333L18.832 36.6666",
    stroke: "#004098",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "link",
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8967 32.273C23.9926 32.3687 24.0686 32.4825 24.1205 32.6077C24.1724 32.7329 24.1991 32.8671 24.1991 33.0026C24.1991 33.1381 24.1724 33.2723 24.1205 33.3975C24.0686 33.5227 23.9926 33.6364 23.8967 33.7322L22.1865 35.4406C20.4457 37.1815 18.0846 38.1595 15.6226 38.1595C13.1607 38.1595 10.7996 37.1815 9.0587 35.4406C7.31785 33.6998 6.33984 31.3387 6.33984 28.8767C6.33984 26.4148 7.31785 24.0537 9.0587 22.3128L13.2026 18.1672C14.8764 16.4915 17.1275 15.5191 19.4949 15.4491C21.8624 15.3791 24.167 16.2169 25.9368 17.7908C26.0384 17.8811 26.1212 17.9905 26.1805 18.1127C26.2398 18.235 26.2744 18.3678 26.2824 18.5034C26.2903 18.6391 26.2715 18.775 26.227 18.9034C26.1824 19.0318 26.113 19.1501 26.0228 19.2517C25.9325 19.3533 25.8231 19.4361 25.7008 19.4954C25.5785 19.5546 25.4458 19.5893 25.3101 19.5972C25.1744 19.6052 25.0385 19.5864 24.9101 19.5419C24.7818 19.4973 24.6634 19.4279 24.5618 19.3376C23.1854 18.1149 21.3938 17.4643 19.5535 17.519C17.7132 17.5736 15.9633 18.3293 14.6618 19.6316L10.5162 23.7703C9.1619 25.1246 8.40106 26.9614 8.40106 28.8767C8.40106 30.792 9.1619 32.6288 10.5162 33.9831C11.8705 35.3374 13.7073 36.0983 15.6226 36.0983C17.5379 36.0983 19.3747 35.3374 20.729 33.9831L22.4375 32.273C22.5332 32.1771 22.647 32.101 22.7722 32.0491C22.8973 31.9972 23.0315 31.9705 23.1671 31.9705C23.3026 31.9705 23.4368 31.9972 23.562 32.0491C23.6872 32.101 23.8009 32.1771 23.8967 32.273ZM35.94 8.55421C34.198 6.81551 31.8373 5.83899 29.376 5.83899C26.9148 5.83899 24.5541 6.81551 22.8121 8.55421L21.102 10.2626C20.9085 10.4562 20.7998 10.7186 20.7998 10.9923C20.7998 11.2659 20.9085 11.5284 21.102 11.7219C21.2955 11.9154 21.5579 12.0241 21.8316 12.0241C22.1052 12.0241 22.3677 11.9154 22.5612 11.7219L24.2696 10.0031C25.6239 8.64881 27.4608 7.88797 29.376 7.88797C31.2913 7.88797 33.1281 8.64881 34.4825 10.0031C35.8368 11.3574 36.5976 13.1943 36.5976 15.1095C36.5976 17.0248 35.8368 18.8616 34.4825 20.2159L30.3368 24.3736C29.0353 25.6758 27.2855 26.4315 25.4452 26.4862C23.6049 26.5408 21.8133 25.8902 20.4368 24.6675C20.2317 24.4852 19.9625 24.3918 19.6886 24.4079C19.4146 24.424 19.1582 24.5483 18.9759 24.7534C18.7936 24.9586 18.7002 25.2277 18.7163 25.5017C18.7324 25.7757 18.8567 26.032 19.0618 26.2144C20.8315 27.7873 23.1354 28.6244 25.502 28.5544C27.8686 28.4844 30.119 27.5127 31.7926 25.838L35.9365 21.6923C36.7997 20.8306 37.4845 19.8071 37.9519 18.6805C38.4193 17.5539 38.66 16.3463 38.6603 15.1266C38.6606 13.9069 38.4205 12.6991 37.9538 11.5722C37.487 10.4454 36.8027 9.42157 35.94 8.55937V8.55421Z",
    fill: "#004098"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrowDown",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashicons:arrow-down-alt2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5477 6L10.1082 11.5L4.66861 6L3.1851 7L10.1082 14L17.0313 7L15.5477 6Z",
    fill: "#9EA9B7"
  })))), "xml version=\"1.0\" encoding=\"utf-8\" id=\"spinner\"?>\n    ", /*#__PURE__*/React.createElement("symbol", {
    id: "spinner",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(255, 255, 255)",
      display: "block",
      shapeRendering: "auto"
    },
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.7360959651035986s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(12.857142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.7088331515812432s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25.714285714285715 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.6815703380588877s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(38.57142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.6543075245365322s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(51.42857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.6270447110141767s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(64.28571428571429 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.5997818974918212s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(77.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.5725190839694656s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.5452562704471101s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(102.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.5179934569247546s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(115.71428571428571 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.49073064340239914s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(128.57142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.46346782988004365s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(141.42857142857142 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.4362050163576881s",
    repeatCount: "indefinite"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.28571428571428 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.4089422028353326s",
    repeatCount: "indefinite"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(167.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.3816793893129771s",
    repeatCount: "indefinite"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.3544165757906216s",
    repeatCount: "indefinite"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(192.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.3271537622682661s",
    repeatCount: "indefinite"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.71428571428572 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.2998909487459106s",
    repeatCount: "indefinite"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(218.57142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.27262813522355506s",
    repeatCount: "indefinite"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(231.42857142857142 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.24536532170119957s",
    repeatCount: "indefinite"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(244.28571428571428 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.21810250817884405s",
    repeatCount: "indefinite"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(257.14285714285717 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.19083969465648856s",
    repeatCount: "indefinite"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.16357688113413305s",
    repeatCount: "indefinite"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(282.85714285714283 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.13631406761177753s",
    repeatCount: "indefinite"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(295.7142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.10905125408942203s",
    repeatCount: "indefinite"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(308.57142857142856 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.08178844056706652s",
    repeatCount: "indefinite"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(321.42857142857144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.05452562704471101s",
    repeatCount: "indefinite"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(334.2857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "-0.027262813522355506s",
    repeatCount: "indefinite"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(347.14285714285717 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 22.5,
    rx: 0,
    ry: 0,
    width: 1,
    height: 15,
    fill: "#004098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7633587786259541s",
    begin: "0s",
    repeatCount: "indefinite"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.e221494b5810921c921d3f6106ed2907.svg";
export { ForwardRef as ReactComponent };